// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"aws":"50fabebe","lsc":"cbace2a1","others":"98f0ddf6"}[chunkId] + ".chunk.js";
};